import React from 'react';
import cx from 'classnames';

import { ColorTokenProp } from '../../../theme/tokens/color';
import { FontWeightProp } from '../../../theme/tokens/font-weight';

import GlLink from '../../Link';

import { NodeProps } from './shared';

interface EmbeddedInlineEntryNodeProps extends NodeProps {
  colour: ColorTokenProp | string;
  fontWeight?: FontWeightProp;
  func?: () => void;
}
export function EmbeddedInlineEntryNode({
  node,
  colour,
  fontWeight = 'inlineAnchor',
  func
}: EmbeddedInlineEntryNodeProps) {
  const { fields, sys } = node.data?.target ?? {};
  const { url, title, openInNewTab } = fields ?? {};

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (func) func();

    window.location.href = url;
  };

  if (sys?.contentType?.sys?.id === 'link') {
    const colorClasses = {
      defaultText: 'text-black hover:text-navy desktop:hover:text-navy',
      inputLabelText: 'text-dark-gray hover:text-navy desktop:hover:text-green'
    };

    const fontWeightClasses = {
      p: 'font-normal',
      inlineAnchor: 'font-semibold',
      '400': 'font-normal',
      '500': 'font-medium',
      '600': 'font-semibold'
    };

    const colorClass =
      typeof colour === 'string'
        ? colorClasses[colour as keyof typeof colorClasses] ||
          colorClasses.defaultText
        : colorClasses.defaultText;

    const weightClass =
      fontWeight &&
      fontWeightClasses[fontWeight as keyof typeof fontWeightClasses]
        ? fontWeightClasses[fontWeight as keyof typeof fontWeightClasses]
        : fontWeightClasses.inlineAnchor;

    return (
      <GlLink
        href={url}
        target={openInNewTab ? '_blank' : undefined}
        className={cx(
          'underline transition-colors duration-200 ease-in-out',
          colorClass,
          weightClass
        )}
        {...(func && { onClick: handleClick })}
      >
        {title}
      </GlLink>
    );
  } else {
    return null;
  }
}
